import React, { useRef } from "react";
import ManuallyScoreTicketsTable from "./ManuallyScoreTicketsTable";

const ManuallyScoreTicketsModal = ({
  manuallyScoreTickets,
  getManuallyScoreTickets,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  scoreTicketList,
}) => {
  const closeButtonRef = useRef();

  // This function is used to close the modal when the user clicks the close button
  const closeModal = () => {
    closeButtonRef.current.click();
    setSelectedTicketsVoidScore([]);
  };

  const refreshTickets = () => {
    getManuallyScoreTickets();
    setSelectedTicketsVoidScore([]);
  };

  return (
    <>
      <div
        className="modal fade"
        id="manuallyScoreTicketsModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="manuallyScoreTicketsModal">
                Manually Score Tickets
              </h5>
              <span
                data-dismiss="modal"
                ref={closeButtonRef}
                style={{ cursor: "inherit" }}
              ></span>
              <button type="button" className="close" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-body">
              <ManuallyScoreTicketsTable
                manuallyScoreTickets={manuallyScoreTickets}
                selectedTicketsVoidScore={selectedTicketsVoidScore}
                setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              />
            </div>
            <div className="modal-footer">
              <div className="col-sm-6">
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={() => refreshTickets()}
                >
                  Refresh
                </button>
              </div>
              <div
                className="col-sm-6"
                style={{ textAlign: "right", paddingRight: "0px" }}
              >
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => scoreTicketList(true)}
                >
                  Score Tickets
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManuallyScoreTicketsModal;
